import { ENTER_OTP_VALUE, GET_FORM_PROGRESS, OTP_SENT, get_token } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { validate_numbers } from '@/utils/validations/validate_inputs';
import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';

export default {
  name: 'OneTimePin',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex
  },
  data() {
    return {
      user_id: null,
      token: null,
      title: "Verify Your Account",
      submitButtonText: "Continue",
      verification_running: false,
      otp_number: '',
      otp_sending: false,
      first_time_login: false,
      profile_role_form_id: '',
      is_lead: false,
      application_form_id: null,
      has_resent_otp: false
    };
  },

  mounted() {
    // Get first_time_login from sessionStorage and convert to boolean
    const first_time_login = sessionStorage.getItem('first_time_login');
    this.first_time_login = first_time_login === 'true'; // Convert string to boolean

    const is_lead = sessionStorage.getItem('is_lead');
    this.is_lead = is_lead === 'true';

    const redirect_reason = sessionStorage.getItem('auth_redirect_reason');
    if (redirect_reason) {
      this.show_error(redirect_reason);
      sessionStorage.removeItem('auth_redirect_reason');
    }

    this.user_id = sessionStorage.getItem('user_id');
    this.profile_role_form_id = sessionStorage.getItem('profile_role_form_id');

    this.application_form_id = sessionStorage.getItem('application_form_id')

    this.token = get_token();
  },

  methods: {
    validate_numbers,

    async check_form_progress() {
      if (!this.user_id) return this.show_error('User identification is missing. Please try resending OTP.') &&
        { form_completed: false, current_section_index: 0 };

      try {
        const params = this.application_form_id
          ? { application_form_id: this.application_form_id }
          : { user_id: this.user_id };

        const response = await axios.get(GET_FORM_PROGRESS, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${this.token}`
          },
          params
        });

        if (response.data.status === 'success')
          return {
            ...(response.data.application_form_id && {
              application_form_id: (this.application_form_id = response.data.application_form_id),
              set_session: sessionStorage.setItem('application_form_id', this.application_form_id)
            }),
            form_completed: response.data.is_completed || false,
            current_section_index: response.data.current_section_index || 0
          };

        const filled_form = { form_completed: false, current_section_index: 0 };
        return filled_form;

      } catch (error) {
        return { form_completed: false, current_section_index: 0 };
      }
    },

    async handle_enter_otp() {
      this.verification_running = true;
      var data = {
        one_time_password: this.otp_number,
        user_id: this.user_id
      };
      try {
        let response = await axios.post(ENTER_OTP_VALUE, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${this.token}`
          }
        });
        var response_data = JSON.parse(response.data);
        if (response_data.status == 'success') {
          sessionStorage.setItem('otp_verified', true);
          this.show_success('OTP verified successfully');
          this.verification_running = false;

          await this.handle_post_otp_redirection();

        } else {
          this.show_error('Error during the form submit');
          this.verification_running = false;
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.show_error(error.response.data.message || 'Please enter a valid OTP provided.');
        }
        this.verification_running = false;
      }
    },

    async handle_post_otp_redirection() {
      const userRole = sessionStorage.getItem('user_role');

      const progress = await this.check_form_progress();

      if (userRole === 'Entity') {
        if (progress.form_completed) {
          this.$router.push('/entity_overview');
        }
        else {
          this.$router.push({
            path: '/attribute_forms',
          });
        }
      } else if (userRole === 'Lead') {
        this.$router.push('/entity_enquiry_management');
      } else {
        this.$router.push('/company_management');
      }
    },

    async resend_otp() {
      if (this.otp_sending) return;

      this.otp_sending = true;
      try {
        const response = await axios.post(OTP_SENT, { user_id: this.user_id }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${this.token}`
          }
        });

        if (response.data.status === 'success') {
          this.show_success('OTP has been resent successfully.');

          if (response.data.user_id) {
            this.user_id = response.data.user_id;
            sessionStorage.setItem('user_id', this.user_id);
          }

          this.has_resent_otp = true;
        } else {
          this.show_error('Could not send OTP.');
        }
      } catch (error) {
        this.show_error('Could not send otp to user.');
      } finally {
        this.otp_sending = false;
      }
    }
  }
};